import { Component, Input } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';

/**
 * Generated class for the HoikuchuFukajikoModalPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-hoikuchu-fukajiko-modal',
  templateUrl: 'hoikuchu-fukajiko-modal.html',
})
export class HoikuchuFukajikoModalPage {

  other_questions: string[] = [];

  list = [
    { name: "バンボ", value: "1" },
    { name: "抱っこひも", value: "2" },
    { name: "おんぶひも", value: "3" },
    { name: "散歩", value: "4" },
    { name: "虫除け", value: "5" },
    { name: "プール(別途料金)", value: "6" },
  ];

  constructor(public navCtrl: NavController, public navParams: NavParams, public viewController: ViewController) {
  }

  ionViewDidLoad() {
    this.other_questions = this.navParams.data?.other_questions || [];
  }

  onChangeValue(value) {
    // 選択肢をひっくり返す
    let isDelete = false;
    this.other_questions = this.other_questions.filter(v => {
      // 個別項目の操作をする場合は、 "すべて可" の項目は、除外する
      if (v === '99') return false;

      if (v === value) {
        isDelete = true;
        return false;
      }
      return true;
    });
    if (!isDelete) {
      this.other_questions.push(value);

    }
    console.log(value, this.other_questions);
  }

  onClickAll() {
    if (this.other_questions.includes('99')) {
      this.other_questions = [];
    } else {
      this.other_questions = ['99'];
    }
  }


  save() {
    this.viewController.dismiss({
      other_questions: this.other_questions
    })
  }

}



// WEBPACK FOOTER //
// ./src/pages/_com/hoikuchu-fukajiko-modal/hoikuchu-fukajiko-modal.ts